export default {
  modifiers: {
    possessiv: (str: string = '') =>
      ['s', 'ß', 'x', 'z'].includes(str?.slice(-1)) ? `${str}'` : `${str}s`,
  },
}
